import dayjs from 'dayjs';
import {
  isEmptyString,
} from './misc';

export const DASHBOARD_DATE_KEY = 'dashboard-date';

export function readDashboardDate(): string | null {
  try {
    if (typeof window !== 'undefined') {
      const value = window.localStorage.getItem(DASHBOARD_DATE_KEY);
      return !isEmptyString(value) && dayjs(value).isValid() ? value : null;
    }
    return null;
  } catch {
    return null;
  }
}

export function writeDashboardDate(value: string): void {
  try {
    if (typeof window !== 'undefined' && !isEmptyString(value)){
      localStorage.setItem(DASHBOARD_DATE_KEY, value);
    }
  } catch {
    // ignore
  }
}